import React, { useState } from "react";
import EntryLevelNavbar from "../Navbar/EntryLevelNavbar.jsx";
import SocialMediaContainer from "./SocialMediaContainer.jsx";
import Label from "../Label/Label.jsx";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../services/api/axiosInstance.js";
import Modal from 'react-bootstrap/Modal';
import { IoIosInformationCircleOutline } from "react-icons/io";


const EntryLevelRightSideContainer = ({
  loginMode,
  formTitle,
  form,
  formName,
  formWidth,
  formHeaderClassName,
  formFooterQuestion,
  footerNavigationLink,
  footerNavigationTestId,
  footerNavigateLinkContent,
  selectionType,
  buttonId,
  visibleResendLink,
  timeLeft,
  setTimeLeft,
  resendMailAccessToken,
  emailIdForResendEmail,

  professionalVisibleResendLink,
  professionalTimeLeft,
  setProfessionalTimeLeft,
  professionalResendMailAccessToken,
  professionalEmailIdForResendEmail,

  partnerVisibleResendLink,
  partnerTimeLeft,
  setPartnerTimeLeft,
  partnerResendMailAccessToken,
  partnerEmailIdForResendEmail,


}) => {

  const pageRender = useNavigate();
  const [appleIconModal, setAppleIconModal] = useState(false)
  let appleRedirectURl;

  if (loginMode === "signup") {
    appleRedirectURl = `${process.env.REACT_APP_API_URL}/apple_signup`;

  } else if (loginMode === "signin") {
    appleRedirectURl = `${process.env.REACT_APP_API_URL}/apple_signin`;
  }

  const handlePartnerResendEmailClick = async () => {

    setPartnerTimeLeft(90)

    const requiredParams = {
      email_id: partnerEmailIdForResendEmail
    }

    try {


      const response = await axiosInstance.post(
        "/resend_email", requiredParams, {
        headers: {
          Authorization: `Bearer ${partnerResendMailAccessToken}`
        }
      }
      );

    } catch (err) {
      console.log(err);
    }
  }


  const handleProfessionalResendEmailClick = async () => {

    setProfessionalTimeLeft(90)

    const requiredParams = {
      email_id: professionalEmailIdForResendEmail
    }

    try {


      const response = await axiosInstance.post(
        "/resend_email", requiredParams, {
        headers: {
          Authorization: `Bearer ${professionalResendMailAccessToken}`
        }
      }
      );

    } catch (err) {
      console.log(err);
    }
  }


  const handleResendEmailClick = async () => {

    setTimeLeft(90)

    const requiredParams = {
      email_id: emailIdForResendEmail
    }

    try {


      const response = await axiosInstance.post(
        "/resend_email", requiredParams, {
        headers: {
          Authorization: `Bearer ${resendMailAccessToken}`
        }
      }
      );

    } catch (err) {
      console.log(err);
    }
  }


  const location = useLocation()


  return (
    <div className="col-md-8 col-lg-7">
      <EntryLevelNavbar />
      <div className="login d-flex align-items-center overflow-scroll">
        <div className="container">
          <div className="row">
            <div className="login-content-container">
              <div className={`${formWidth} mx-auto py-5`}>
                <h4 className={`${formHeaderClassName} `}>{formTitle}</h4>
                {form}

                {selectionType}

                {formName === "login" ? <SocialMediaContainer loginMode={loginMode} setAppleIconModal={setAppleIconModal} /> : null}

                <div className="text-center mt-3" >
                  {formFooterQuestion}
                  <Link
                    to={footerNavigationLink}
                    data-testid={footerNavigationTestId}
                    id={buttonId}
                  >
                    <Label
                      className="brand-color ms-1 signup-link"
                      title={footerNavigateLinkContent}
                    />
                  </Link>
                  {
                    location.pathname === "/" ?
                      <p className="contact-info-content">If you have any issues, please contact us at info@2ndcareers.com</p>
                      : null
                  }
                </div>

                {
                  visibleResendLink ?
                    <p className="my-2 text-center">
                      Didn't receive verification email?
                      <a onClick={handleResendEmailClick} className={timeLeft === null ? 'd-inline resend-email' : 'pe-none opacity-75 text-grey'}> Resend email</a>
                      <span className={timeLeft === null ? "d-none" : "d-inline"}> in {timeLeft} seconds</span>
                    </p>
                    :
                    null
                }

                {
                  professionalVisibleResendLink ?
                    <p className="my-2 text-center">
                      Didn't receive verification email?
                      <a onClick={handleProfessionalResendEmailClick} className={professionalTimeLeft === null ? 'd-inline resend-email' : 'pe-none opacity-75 text-grey'}> Resend email</a>
                      <span className={professionalTimeLeft === null ? "d-none" : "d-inline"}> in {professionalTimeLeft} seconds</span>
                    </p>
                    :
                    null
                }

                {
                  partnerVisibleResendLink ?
                    <p className="my-2 text-center">
                      Didn't receive verification email?
                      <a onClick={handlePartnerResendEmailClick} className={partnerTimeLeft === null ? 'd-inline resend-email text-decoration-none fw-bold' : 'text-decoration-none pe-none opacity-75 text-grey'}> Resend email</a>
                      <span className={partnerTimeLeft === null ? "d-none" : "d-inline"}> in {partnerTimeLeft} seconds</span>
                    </p>
                    :
                    null
                }
              </div>
            </div>
          </div>
        </div>


        <Modal
          show={appleIconModal}
          backdrop="static"
          keyboard={false}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          contentClassName="rounded-4"
        >
          <Modal.Body>
            <div className="py-4 px-2 col-12">
              <div className="row justify-content-center col-12 text-center">
                {/* <div className="col-6 text-center">
                  <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}subscription-expired.png`} alt='subscription expired' with={135} height={135} />
                </div> */}

                <div className="col-12">
                  <div className="py-2">
                    <div className="d-flex align-items-center justify-content-center mb-3">
                      <p className="mb-0"><IoIosInformationCircleOutline className="fs-3 brand-color me-2" /></p>
                      <h5 className="mb-0"> Please Don’t Hide Your Email</h5>
                    </div>
                  </div>

                  <p className="text-mute mb-0">To ensure you receive important communications and updates, please do not hide your email when signing up through Apple.</p>

                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="col-lg-12 d-flex justify-content-between gap-2 mx-auto w-100">
              <button
                id="cancelButton"
                type="button"
                className="btn w-100 btn-outline-secondary my-2"
                onClick={() => setAppleIconModal(false)}
              >
                Cancel
              </button>
              <Link to={appleRedirectURl} className=" w-100">
                <button
                  id="proceedButton"
                  type="button"
                  className="btn btn-brand-color my-2 w-100"
                  onClick={() => {
                    setAppleIconModal(false)
                  }}
                >
                  Proceed
                </button>
              </Link>
            </div>
          </Modal.Footer>
        </Modal>

      </div>
    </div>
  );
};

export default EntryLevelRightSideContainer;
